/*
    GALLERY
*/

// Background
var select = document.getElementById('gallery-color-selector');
var colorPreview = document.getElementById('color-preview-gallery');
window.updateColorBackgroundGallery = function() {
    select.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}

select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle['.cognigy-webchat-1mv2cde']['background-color'] = val.settings.color;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.cognigy-webchat-1mv2cde']['background-color'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }

})

// Font Title
var selectFontTitle = document.getElementById("gallery-title-text-font-selector");
window.updateGalleryTitleFonts = function() {
    selectFontTitle.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFontTitle.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFontTitle.appendChild(option);
    }
}
selectFontTitle.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFontTitle.style.color = val.settings.color;
            selectFontTitle.style.fontFamily = val.settings.fontFamily;
            selectFontTitle.style.fontSize = val.settings.size;

            window.customStyle[".cognigy-webchat-12tlige"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".cognigy-webchat-12tlige"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".cognigy-webchat-12tlige"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Font Subtitle
var selectFontSubtitle = document.getElementById("gallery-subtitle-text-font-selector");
window.updateGallerySubtitleFonts = function() {
    selectFontSubtitle.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFontSubtitle.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFontSubtitle.appendChild(option);
    }
}
selectFontSubtitle.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFontSubtitle.style.color = val.settings.color;
            selectFontSubtitle.style.fontFamily = val.settings.fontFamily;
            selectFontSubtitle.style.fontSize = val.settings.size;

            window.customStyle[".cognigy-webchat-14qz9ku"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".cognigy-webchat-14qz9ku"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".cognigy-webchat-14qz9ku"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})